<template>
  <AdminInsuranceRequirementsPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminInsuranceRequirementsPage from "shared-ui/pages/AdminInsuranceRequirementsPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("admin_insurance.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
